import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Ressult() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#207146" }}>Results</span>
            </h2>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-lg-1"
          >
            <p>
              A holistic application that embodies an ideal balance between
              functionality and user-friendliness, TVM represents the ultimate
              experience of convenience, whether you’re an individual or
              representing a church. Who says religion, community and fellowship
              has no place in the digital world? With apps like TVM we’re
              revolutionizing the way people stay informed and connected, in all
              these aspects.
            </p>
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center"
          >
            <StaticImage
              src="../../../images/case-studies/true-wine/result_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1929}
              height={1205}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ressult;
